

































































import { Component, Mixins } from 'vue-property-decorator';
import { getDefaultAcceptForm } from '@/components/popup/claim/claimOptions';
import ClaimPopupMixin from '@/components/popup/claim/ClaimPopupMixin';
import ClaimProduct from '@/components/popup/claim/ClaimAcceptPopup/ClaimProduct.vue';
import ClaimInformation from '@/components/popup/claim/ClaimAcceptPopup/ClaimInformation.vue';
import OrderInformation from '@/components/popup/claim/ClaimAcceptPopup/OrderInformation.vue';
import ReturnAmount from '@/components/popup/claim/ClaimAcceptPopup/ReturnAmount.vue';
import NoLocalStorageWindowPopup from '@/views/popups/NoLocalStorageWindowPopup.vue';

// 반품리스트 기획서 p.58
// 반품처리내역과 반품승인처리 팝업 디자인이 다름
@Component({
  components: {
    ClaimProduct,
    ClaimInformation,
    OrderInformation,
    ReturnAmount,
  },
})
export default class ReturnAcceptPopup extends Mixins(ClaimPopupMixin, NoLocalStorageWindowPopup) {
  private formData = {
    deliveryCompanyType: '',
    invoiceNo: '',
    evadesReturnProcess: false, // TODO:  무적반품
  };

  async created() {
    await this.fetchClaimNo();
    this.setDefaultForm();
  }

  private setDefaultForm() {
    this.formData = getDefaultAcceptForm(this.claimNoResponse);
  }

  private async acceptReturn() {
    if (!confirm(this.$t('CLAIM.MESSAGE.CONFIRM_RETURN_ACCEPT') as string)) {
      return;
    }

    const { no: claimNo } = this.claimNoResponse;
    const { deliveryCompanyType, invoiceNo, evadesReturnProcess } = this.formData;

    await this.$api.putReturnsNoApprove({
      pathParams: {
        no: claimNo.toString(),
      },
      data: {
        deliveryCompanyType: deliveryCompanyType.length ? deliveryCompanyType : null,
        invoiceNo: invoiceNo ? invoiceNo : null,
        evadesReturnProcess: evadesReturnProcess,
      },
    });
    alert(this.$t('CLAIM.MESSAGE.COMPLETE_PROCESS'));
    this.onPositiveClick();
  }
}
